import React from 'react';
import { useTheme } from 'styled-components';
import { useTranslate } from '@/translations';
import { PageContainer, Title, faCalendar } from '@/ui/components';
import { Card } from 'antd';
import { ShippingPlanDataGrid } from './components/ShippingPlanDataGrid';

export const ShippingPlan = () => {
  const { t } = useTranslate();
  const { shippingPlanLink } = useTheme();

  return (
    <PageContainer>
      <Title
        title={t('shippingPlan')}
        icon={faCalendar}
        color={shippingPlanLink}
      />
      <Card>
        <ShippingPlanDataGrid />
      </Card>
    </PageContainer>
  );
};
